import React, { useEffect, useState } from "react";
import dots from "../assets/images/dots.svg";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import { Dropdown, Space, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";

const SearchApp = (props) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  let employees = props.data;
  let loading = props.loader;
  let lastPageNumber = props.pagen;
  let lastPage = props.page1;

  const handleChange = (event) => {
    let searchValue = event.target.value;
    setPage(0);
    setSearch(searchValue);
  };
  const handlePage = (page) => {
    setPage(page);
  };
  let searchString = search.trim().toLowerCase();

  if (searchString.length > 0) {
    employees = employees.filter((e) =>
      e.name.toLowerCase().match(searchString)
    );
  }
  return (
    <div class="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div class="dashboard_header">
            <div class="left-side d-flex ">
              {" "}
              <button
                type="button"
                id="sidebarCollapse"
                class="btn btn-link bt_none"
              >
                <i class="fa fa-align-left"></i>{" "}
              </button>
              <h1>Teams</h1>
            </div>
            <div class="user_profile   ">
              <DropdownRight />
            </div>
          </div>
        </header>
        <UserInput
          update={(e) => handleChange(e)}
          handlePage={(page) => handlePage(page)}
        />
        <Table
          data={employees}
          loader={loading}
          page={page}
          handlePage={(page) => handlePage(page)}
          lastPage={lastPage}
          lastPageNumber={lastPageNumber}
          refreshTable={props.refreshTeam}
        />
      </div>
    </div>
  );
};
const Table = (props) => {
  // const [pageNumber, setPageNumber] = useState(0);
  useEffect(() => {
    // setPageNumber(props.page);
  }, []);

  let loading = props.loader;
  let lastPage = props.lastPage;
  let lastPageNumber = props.lastPageNumber;

  const usersPerPage = 7;
  const pagesVisited = props.page * usersPerPage;

  const pageCount = Math.ceil(props.data.length / usersPerPage);
  const listTeams = props.data.length;
  const [pageNumber, setPageNumber] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteTeamId, setDeleteTeamId] = useState(0);
  const [deleteTeamName, setDeleteTeamName] = useState("");
  const [error, setError] = useState("");

  const changePage = ({ selected }) => {
    props.handlePage(selected);
    setPageNumber(selected);
  };
  const handleOk = () => {
    setConfirmLoading(true);
    const token = localStorage.getItem("xAuthToken");
    http
      .delete(`api/admin/team/${deleteTeamId}?token=${token}`)
      .then((res) => {
        setOpen(false);
        setConfirmLoading(false);
        setDeleteTeamId(0);
        props.refreshTable();
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const handleCancel = () => {
    setOpen(false);
    setDeleteTeamId(0);
    setConfirmLoading(false);
  };
  const showModal = () => {
    setOpen(true);
  };
  const onDelete = (item) => {
    setDeleteTeamId(item.id);
    setDeleteTeamName(item.name);
    showModal();
  };
  return (
    <>
      <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
        <Modal
          title={
            <div>
              Are you sure want to delete {deleteTeamName} Team? <br /> This
              Action Can't be Undone.
            </div>
          }
          centered
          open={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
        >
          <p>
            It will delete related entities Coaches, Parents, Swimmers,
            Subscriptions, Orders, Payments, Team Groups, Filmers, Recordings
          </p>
        </Modal>
        <table class="table table-borderless table-responsive-md">
          <thead>
            <tr>
              {/* <th scope="col" className="  pl_25">
                Team ID
              </th> */}
              <th scope="col" className=" ">
                Team Name
              </th>
              <th scope="col" className=" ">
                Coach
              </th>
              <th scope="col" className=" ">
                Mailing Address
              </th>
              <th scope="col" className=" text-center">
                Swimmers
              </th>
              <th scope="col" className=" text-center">
                Groups
              </th>
              <th scope="col" className="  text-center"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <div
                style={{
                  position: "absolute",
                  marginTop: 250,
                  backgroundColor: "#ffffffc2",
                  marginLeft: 580,

                  backgroundBlendMode: "overlay",
                  zIndex: 100,
                }}
              >
                <SpinnerCircular size="15%" />
              </div>
            ) : (
              <>
                {props.data
                  .slice(pagesVisited, pagesVisited + usersPerPage)
                  .map(function (d, i) {
                    return (
                      <TableRow
                        key={"person-" + i}
                        id={d.id}
                        name={d.name}
                        email={d.email}
                        mailing_address={d.mailing_address}
                        swimmers={d.swimmers}
                        groupes={d.groupes}
                        coach={d.coach}
                        onDelete={onDelete}
                      />
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="paginateText">
          <p className="text-table-show">
            {" "}
            Showing{" "}
            {pageNumber === lastPage - 1 ? lastPageNumber : usersPerPage} out of{" "}
            {listTeams} entries
          </p>
        </div>
        <div className="reactPaginate">
          <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
          />
        </div>
      </div>
    </>
  );
};

const UserInput = (props) => {
  return (
    <div class="analysts-wraper-head">
      <div class="form-group search_wraper">
        <input
          onChange={(e) => {
            props.update(e);
            props.handlePage(0);
            //  changePage({ selected: 0 });
          }}
          name=""
          class="form-control custom_input"
          placeholder="Search here"
        />
      </div>
      <div class="map_btn">
        <Link to="/newTeams" class="them_btn">
          Add New Team
        </Link>
      </div>
    </div>
  );
};

const TableRow = (props) => {
  const items = [
    {
      label: (
        <Link to={`/teamShark/${props.id}`} style={{ width: 10 }}>
          Details
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <a href="#" onClick={() => props.onDelete(props)}>
          Delete Team
        </a>
      ),
      key: "1",
    },
    // {
    //   type: 'divider',
    // },
    // {
    //   label: '3rd menu item',
    //   key: '3',
    // },
  ];

  return (
    <tr>
      {/* <td className="pl_25">{props.id}</td> */}
      <td>{props.name}</td>
      <td className="">{props.coach ? props.coach : "-"}</td>
      <td>{props.mailing_address}</td>
      <td className="text-center">{props.swimmers}</td>
      <td className="text-center">{props.groupes}</td>


      <td className="text-center">
        <div className="dropdown wraper_btn">
          <Dropdown menu={{ items }} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <img src={dots} className="img-fulid  " style={{ width: 25 }} />
                {/* <DownOutlined /> */}
              </Space>
            </a>
          </Dropdown>
          {/* <button
              className="btn dropdown-toggle"
              type="button"
              data-toggle="dropdown"
            >
              <Link to={`/teamShark/${props.id}`} style={{ width: 10 }}>
                <img src={dots} className="img-fulid  " style={{ width: 25 }} />
              </Link>

              <span className="caret"></span>
            </button>
            <ul className="dropdown-menu">
              <li>
                <Link to="#">View Profile</Link>
              </li>
              <li>
                <Link to="#" className="text-danger">
                  Deactivate
                </Link>
              </li>
            </ul> */}
        </div>
      </td>
    </tr>
  );
};

export default function Teams() {
  const token = localStorage.getItem("xAuthToken");
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;

  useEffect(() => {
    Analyst();
  }, []);

  const Analyst = async () => {
    setLoading(true);

    http
      .get(`api/admin/team?token=${token}`)
      .then((res) => {
        setLoading(false);
        setTeam(res.data);
        setLastPageNumber(res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const refreshTeamList = () => {
    Analyst();
  };
  return (
    <>
      <SearchApp
        data={team}
        loader={loading}
        pagen={lastPageNumber}
        page1={lastPage}
        refreshTeam={refreshTeamList}
      />
    </>
  );
}
